// @ts-nocheck
import React from 'react';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import Card from 'atoms/card/card';
import Divider from 'atoms/divider/divider';
import Heading from 'atoms/heading/heading';
import { useDispatch, useSelector } from 'react-redux';
import * as dynamicGridSelectors from 'models/dynamicGrid/selector';

import { formatThousands, formatPercentage, formatMoney } from 'utils/utilities';
import { useEffect } from 'react';
import * as sagaActions from './sagaActions';
import { Typography } from 'antd';

const { Title, Text } = Typography;
export interface Props {
	tableId: number;
}

const NotificationCard = ({ heading, primaryText, secondaryText, value }) => {
	return (
		<Card className="availability-Info-card">
			<Stack className="availability-status-card">
				<StackItem>
					<Title level={4} className="availability">
						{heading}
					</Title>
				</StackItem>
				<StackItem className="w-100">
					<Stack className="status-items">
						<StackItem className="status-item">
							<Title level={5}>Cost</Title>
							<Title level={4}>{primaryText}</Title>
						</StackItem>
						<StackItem className="status-item">
							<Title level={5}>Quantity</Title>
							<Title level={4}>{value}</Title>
						</StackItem>
					</Stack>
				</StackItem>
			</Stack>
		</Card>
	);
};

const NotificationCards: React.FunctionComponent<Props> = ({ tableId, availabilityInfo }) => {
	const dispatch = useDispatch();

	const filters = useSelector((state) => dynamicGridSelectors.getGridFilters(state, tableId));

	useEffect(() => {
		if (!filters?.search) {
			return;
		}
		dispatch(sagaActions.getAvailabilityInfo({ tableId }));
	}, [dispatch, filters?.search]);

	return (
		<Stack gutter="medium">
			<StackItem className="availability-status-block">
				<NotificationCard
					heading="Initial Availability"
					primaryText={formatMoney(availabilityInfo?.Initial_Available_Cost || 0)}
					secondaryText={'Quantity'}
					value={formatThousands(availabilityInfo?.Initial_Available_Qty || 0)}
				/>
			</StackItem>
			<StackItem className="availability-status-block">
				<NotificationCard
					heading="Current Availability"
					primaryText={formatMoney(availabilityInfo?.Current_Available_Cost || 0)}
					secondaryText={'Quantity'}
					value={formatThousands(availabilityInfo?.Current_Available_Qty || 0)}
				/>
			</StackItem>
			<StackItem className="availability-status-block">
				<NotificationCard
					heading="On Order"
					primaryText={
						formatMoney(
							Number(availabilityInfo?.Initial_Available_Cost) -
								Number(availabilityInfo?.Current_Available_Cost)
						) || 0
					}
					secondaryText={'Quantity'}
					value={formatThousands(
						Number(availabilityInfo?.Initial_Available_Qty ?? 0) -
							Number(availabilityInfo?.Current_Available_Qty ?? 0)
					)}
				/>
			</StackItem>

			<StackItem className="availability-status-block">
				<NotificationCard
					heading="% Availability Consumed"
					primaryText={
						formatPercentage(
							(availabilityInfo?.Initial_Available_Cost - availabilityInfo?.Current_Available_Cost) /
								availabilityInfo?.Initial_Available_Cost
						) ?? 0
					}
					secondaryText="Quantity"
					value={
						formatPercentage(
							(availabilityInfo?.Initial_Available_Qty - availabilityInfo?.Current_Available_Qty) /
								availabilityInfo?.Initial_Available_Qty
						) ?? 0
					}
				/>
			</StackItem>
		</Stack>
	);
};

export default NotificationCards;
